module.exports = __webpack_public_path__ + "img/bgBox_pc.d1bc47f5.jpg";